import { render, staticRenderFns } from "./ValeGasolinaNew.vue?vue&type=template&id=ee4ed108&scoped=true&"
import script from "./ValeGasolinaNew.vue?vue&type=script&lang=ts&"
export * from "./ValeGasolinaNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4ed108",
  null
  
)

export default component.exports